module.exports = {"firebaseDetails":{"apiKey":"AIzaSyAKxzESnKGeA9Ou40tVg1tVmPEN1FRQwPk","authDomain":"stagiversary-7a7b4.firebaseapp.com","databaseURL":"https://stagiversary-7a7b4.firebaseio.com","projectId":"stagiversary-7a7b4","storageBucket":"stagiversary-7a7b4.appspot.com","messagingSenderId":"81677012888"},"localStorageKey":"STAG","apiOfflineWaitMs":5000,"requestTimeoutLimitMs":10000}


//////////////////
// WEBPACK FOOTER
// ./src/config/core.json
// module id = 63
// module chunks = 0